import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { Mail, ArrowLeft } from 'lucide-react';
import { REQUEST_STORE_PASSWORD_RESET } from '../graphql/queries';

export const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [forgot, { loading }] = useMutation(REQUEST_STORE_PASSWORD_RESET);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSent(null);
    const resetBaseUrl = window.location.origin;
    try {
      const { data } = await forgot({ variables: { email, resetBaseUrl } });
      const r = data?.requestStorePasswordReset;
      if (r?.error) {
        setError(r.message);
        return;
      }
      setSent(r?.message || 'If an account exists, a reset link was sent.');
    } catch (err: any) {
      setError(err?.message || 'Connection error');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#0F172A] via-[#1E1B4B] to-[#0F172A] px-4">
      <div className="w-full max-w-sm bg-white rounded-2xl p-8 shadow-2xl">
        <Link
          to="/login"
          className="inline-flex items-center gap-1 text-xs font-semibold text-text2 hover:text-primary mb-5"
        >
          <ArrowLeft size={13} /> Back to sign in
        </Link>
        <h1 className="text-xl font-black text-text mb-1">Forgot password?</h1>
        <p className="text-xs text-text2 mb-6">Enter your email and we'll send a reset link.</p>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="input-label">Email</label>
            <div className="relative">
              <Mail size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-text3" />
              <input
                type="email"
                className="input-field pl-9"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@store.com"
                required
                autoFocus
              />
            </div>
          </div>

          {error && (
            <div className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg px-3 py-2">
              {error}
            </div>
          )}
          {sent && (
            <div className="text-sm text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-lg px-3 py-2">
              {sent}
            </div>
          )}

          <button type="submit" disabled={loading} className="btn-primary w-full disabled:opacity-60">
            {loading ? 'Sending…' : 'Send reset link'}
          </button>
        </form>
      </div>
    </div>
  );
};
